export default "__VITE_ASSET__BmpQ$n8O__"